import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { palette } from '../../assets/theme/theme';

export default function NoDataToDisplay({height, message} : {height?: number, message?: string}) {


    return (<div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center', height: height?height:300 }}>
        <SentimentVeryDissatisfiedIcon style={{ color: palette.rodrimaq_red, fontSize: '5em' }} />

        <div style={{ marginTop: 20 }}>
            <span style={{ color: palette.rodrimaq_red, fontSize: '1.4em' }}>{message ? message : 'Sem dados disponíveis'}</span>
        </div>
    </div>)


}